module.exports = __webpack_public_path__ + "fonts/Uni Sans Thin.eb17b949.otf";